module.exports = __webpack_public_path__ + "static/media/111.b4d5fc24.png";